import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import Image from "components/landing/image"
import { getUrlProps } from "helpers/landing"

const TextContainer = styled(Box).attrs((props) => ({
  px: { _: 2, tablet: "20px" },
  py: { _: 2, tablet: "20px" },
  ...props,
}))``

const CTA = styled(Button).attrs((props) => ({
  variant: "text",
  ...props,
}))`
  text-decoration: underline;
`

const CTABox = styled(Box).attrs((props) => ({
  fontSize: { _: "16px", desktop: "18px" },
  fontWeight: "400",
  lineHeight: "22px",
  ...props,
}))``

const ImageLink = styled(Button).attrs({
  variant: "text",
})`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;

  &:hover ~ ${TextContainer} {
    ${CTA} {
      text-decoration: none;
    }
  }
`
const LandingCardItem = ({ id, item, lazyload }) => {
  const urlProps = getUrlProps(item.url, id)

  return (
    <Flex
      flexDirection="column"
      justifyContent="space-between"
      position="relative"
      {...item.style?.card_style}
    >
      {item.url && (
        <ImageLink aria-label={item.image?.alt || item.label} {...urlProps} />
      )}
      {(item.label || item.description || item.cta) && (
        <TextContainer {...item.style?.text_container_style}>
          {item.label && (
            <Typography
              dangerouslySetInnerHTML={{
                __html: item.label,
              }}
              mb={1}
              variant="h3"
              {...item.style?.label_style}
            />
          )}
          {item.description && (
            <Typography
              dangerouslySetInnerHTML={{
                __html: item.description,
              }}
              variant="body"
              {...item.style?.description_style}
            />
          )}
          {item.cta && (
            <CTABox {...item.style?.cta_style}>
              <CTA aria-hidden tabIndex="-1" {...urlProps}>
                {item.cta}
              </CTA>
            </CTABox>
          )}
        </TextContainer>
      )}
      <Image image={item.image} lazyload={lazyload} />
    </Flex>
  )
}

LandingCardItem.propTypes = {
  id: PropTypes.string,
  item: PropTypes.object,
  lazyload: PropTypes.bool,
}

const GridContainer = styled(Box).attrs(({ items, ...props }) => ({
  display: "grid",
  gridTemplateColumns: {
    _: items.length % 2 == 1 ? "1fr" : "repeat(2, 1fr)",
    tablet: `repeat(${items.length}, 1fr)`,
  },
  ...props,
}))``

const LandingCardGrid = ({ element, lazyload }) => (
  <Box {...element.style?.block_style}>
    <GridContainer
      containWide={element.contain}
      // eslint-disable-next-line sort-keys
      gap={{ _: "16px 8px", tablet: "16px", desktop: 5 }}
      items={element.data?.items}
      // eslint-disable-next-line sort-keys
      px={{ _: 2, desktop: "60px" }}
      py={{ _: 2, desktop: 3, widescreen: 5 }}
      {...element.style}
    >
      {element.data?.items.map((item, i) => (
        <LandingCardItem
          id={element.anchor_name || element.id}
          item={item}
          key={`landing-card-item-${i}`}
          lazyload={lazyload}
        />
      ))}
    </GridContainer>
  </Box>
)

LandingCardGrid.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingCardGrid
